import { defineComponent, computed } from "vue";
import SvgIcon from "./base/SvgIcon.vue.mjs";
import ArrowStrokeLeftIcon from "./icons/ArrowStrokeLeftIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ArrowStroke",
  props: {
    strokePosition: null,
    arrowDirection: null,
    hasStroke: { type: Boolean }
  },
  emits: ["click-arrow"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const arrowStrokeClass = computed(
      () => `arrow-stroke-container-${props.strokePosition}`
    );
    function handleClickArrow() {
      emits("click-arrow");
    }
    return { __sfc: true, props, emits, arrowStrokeClass, handleClickArrow, SvgIcon, ArrowStrokeLeftIcon };
  }
});
export {
  _sfc_main as default
};
